import { render } from "./QueueAnswerTimeCard.vue?vue&type=template&id=d438356a"
import script from "./QueueAnswerTimeCard.vue?vue&type=script&lang=js"
export * from "./QueueAnswerTimeCard.vue?vue&type=script&lang=js"

import "./QueueAnswerTimeCard.vue?vue&type=style&index=0&id=d438356a&lang=css"
script.render = render

export default script